'use client';

import classNames from 'classnames';
import React from 'react';
import styles from './PlayButton.module.scss';

type PlayButtonProps = {
  isPlaying: boolean,
  onClick: () => void,
  playButtonClassName?: string,
};

const PlayButton = ({
  isPlaying,
  onClick,
  playButtonClassName,
}: PlayButtonProps) => (
  <button
    type='button'
    className={classNames(styles.playButton, playButtonClassName)}
    onClick={onClick}
    aria-label={`${isPlaying ? 'pause' : 'play'} button`}
  >
    <svg className={styles.playButton__default}>
      <use
        href={isPlaying ? '/media/pause-white.svg#pauseWhiteSVG' : '/media/play-white.svg#playWhiteSVG'}
        xlinkHref={isPlaying ? '/media/pause-white.svg#pauseWhiteSVG' : '/media/play-white.svg#playWhiteSVG'}
      />
    </svg>
    <svg className={styles.playButton__hover}>
      <use
        href={isPlaying ? '/media/pause-green.svg#pauseGreenSVG' : '/media/play-green.svg#playGreenSVG'}
        xlinkHref={isPlaying ? '/media/pause-green.svg#pauseGreenSVG' : '/media/play-green.svg#playGreenSVG'}
      />
    </svg>
  </button>
);

export default PlayButton;
